import React, { useState } from 'react';
import { InvestorProjectDetail } from '../models/investors';
import AdminListGroup from '../../../components/admin/AdminListGroup';
import { DisplayItem } from '../../../components/admin/AdminListGroup';
import useAuth from '../../../hooks/useAuth';
import CreatePreBookingModal from './CreatePreBookingModal';

export type Props = {
  project: InvestorProjectDetail;
};

const InvestorProjectActions: React.FC<Props> = ({ project }) => {
  const { isPermissionAvailable } = useAuth();
  const [preBookingModalOpen, setPreBookingModalOpen] = useState(false);
  const fieldMapper: DisplayItem[] = [
    {
      title: (
        <>
          <i className="fa fa-solid fa-plus mr-2" /> Agregar nuevo modelo al
          proyecto
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/models/create`,
    },
    {
      title: (
        <>
          <i className="fa fa-duotone fa-image mr-2" /> Agregar recursos al
          proyecto
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/upload-images`,
    },
    {
      title: (
        <>
          <i className="fa fa-key fa-key mr-2" /> Administrar privacidad de
          proyecto
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/access`,
    },
    {
      title: (
        <>
          <i className="fa fa-calendar fa-calendar mr-2" /> Administrar
          asesorías del proyecto
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/visits`,
    },
    {
      title: (
        <>
          <i className="fa-solid fa-house-circle-check mr-2"></i> Administrar
          unidades del proyecto
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/units`,
    },
    {
      title: (
        <>
          <i className="fa-solid fa-money-bill mr-2"></i> Administrar datos
          financieros masivo
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/bulk-finances`,
    },
    {
      title: (
        <>
          <i className="fa fa-duotone fa-image mr-2"></i> Gestionar amenidades
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/amenities-images`,
    },
    {
      title: (
        <>
          <i className="fa-solid fa-calculator mr-2"></i> Distancia y tiempo de lugares cercanos
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/distances-times`,
    },
    {
      title: (
        <>
          <i className="fa-solid fa-house-circle-check mr-2"></i> Administrar
          layout de marketplace
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/layout-marketplace`,
    },
  ];

  if (project.layout === 'tower') {
    fieldMapper.push({
      title: (
        <>
          <i className="fa fa-building mr-2"></i> Administrar layout de torre
          para proyecto
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/tower-layout`,
    });
  }

  if (isPermissionAvailable('SHOW_MARKETPLACE_SYNC')) {
    fieldMapper.push({
      title: (
        <>
          <i className="fa fa-sync mr-2"></i> Sincronizar con marketplace
        </>
      ),
      value: '',
      href: `/sync-marketplace/${project.id}/project`,
    });
    fieldMapper.push({
      title: (
        <>
          <i className="fa fa-search mr-2"></i> Administrar Tags de Búsqueda
        </>
      ),
      value: '',
      href: `/investors/projects/${project.id}/search-tags`,
    });
  }

  if (project.project_pcv) {
    fieldMapper.push({
      title: (
        <>
          <i className="fa fa-house-circle-check mr-2"></i> Unidades de PCV
        </>
      ),
      value: '',
      href: `/projects/${project.id}/pcvs/list`,
    });
  }

  fieldMapper.push({
    title: (
      <>
        <i className="fa fa-search mr-2"></i> Configurar master plan
      </>
    ),
    value: '',
    href: `/investors/projects/${project.id}/master-plan`,
  });

  fieldMapper.push({
    title: (
      <>
        <i className="fa-solid fa-bookmark mr-2"></i> Crear pre-reserva
      </>
    ),
    value: '',
    onClick: () => setPreBookingModalOpen(true),
  });

  return (
    <>
      <AdminListGroup
        title={'Administrar proyecto'}
        items={fieldMapper}
      ></AdminListGroup>
      <CreatePreBookingModal
        projectId={project.id}
        isOpen={preBookingModalOpen}
        onToggle={() => setPreBookingModalOpen((prev) => !prev)}
      />
    </>
  );
};

export default InvestorProjectActions;
